import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
import { Link, useNavigate   } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';

const PoList = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const TABLE_KEY = 'PurchaseOrders_List';

  const [searchFilter, setSearchFilter] = useState('');

  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];

  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'PurchaseOrder/GetList_paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch, TABLE_KEY]);

  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  const applySearch = () => {
    const newFilters: any[] = [];

    if (searchFilter?.trim()) {
      newFilters.push({
        id: generateFilterId(),
        field: 'code',
        operator: 7, // OpContains
        value: searchFilter.trim()
      });
    }

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  const clearSearch = () => {
    setSearchFilter('');
    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  const displayData = data;

  return (
    <Card>
      <Loading loading={loading} error={error} Type='Dots'>
        <CardHeader className='d-flex justify-content-between align-items-center'>
          <h5 className='m-0'>{t('أوامر الشـراء')}</h5>

          <div className='d-flex gap-2 align-items-center'>
            <div className='input-group' style={{ width: 320 }}>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-search'></i>
              </span>
              <input
                className='form-control'
                value={searchFilter}
                onChange={e => setSearchFilter(e.target.value)}
                placeholder={t('بحث برقم الأمر (PO...)')}
              />
            </div>

            <button
              type='button'
              className='btn btn-theme'
              onClick={applySearch}
              disabled={!searchFilter?.trim()}
              title={t('ApplyFilters')}
            >
              <i className='fas fa-filter fa-fw me-1'></i>
              {t('بحث')}
            </button>

            <button
              type='button'
              className='btn btn-outline-secondary'
              onClick={clearSearch}
              disabled={!filters?.length}
              title={t('ClearFilters')}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>
          </div>
        </CardHeader>

        <CardBody className='p-0'>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small'>{t('Number')}</th>
                  <th className='small'>{t('Date')}</th>
                  <th className='small'>{t('Branch')}</th>
                  <th className='small'>{t('الوصف')}</th>
                  <th className='small text-center'>{t('Actions')}</th>
                </tr>
              </thead>

              <tbody>
                {displayData?.length > 0 ? (
                  displayData.map((item: any) => (
                    <tr key={item.id}>
                      <td className='align-middle'>
                        <strong className='text-theme'>{item.code}</strong>
                      </td>

                      <td className='align-middle'>{String(item.transactionDate || '').split('T')[0]}</td>

                      <td className='align-middle'>
                        {i18n.language === 'en' ? item.organizationName : item.organizationName2}
                      </td>

                      <td className='align-middle'>
                        <span className='text-muted'>{item.description || '-'}</span>
                      </td>

                      <td className='align-middle text-end'>
                        {/* <Link className='btn btn-sm btn-theme' to={getCreateLink(item.id)}> */}
                        <Link
                          className='btn btn-sm btn-theme px-3'
                          to={`${item.id}/AddUpdateViewPurchaseReturn?type=add`}
                          // onClick={() => navigate(`${item.id}/AddUpdateViewPurchaseReturn`)}
                          // onClick={() => navigate(`${item.id}/AddUpdateViewPurchaseReturn?type=add`)}
                        >
                          {/* <i className='bi bi-cart-plus me-2'></i> */}
                          {t('إسترداد')}
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className='text-center py-4 text-muted'>
                      <i className='fa fa-inbox fa-2x mb-2'></i>
                      <br />
                      {filters?.length ? t('NoSearchResults') : t('NoPurchaseRequests')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </CardBody>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Loading>
    </Card>
  );
};

export default PoList;
